import { IconButton, Menu, MenuItem, Stack, Typography } from "@mui/material";
import React from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useDispatch, useSelector } from "react-redux";
import BotAvatar from "./BotAvatar";
import { fonts } from "fonts";
import { botActions } from "store/bot";

export default function BotSelectorMenu() {

  const dispatch = useDispatch();
  const botState = useSelector((state) => state.bot);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  if (botState.loading || botState.bots.lenght === 0) return null;

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSelectBot = (bot) => {
    dispatch(botActions.selectBot(bot.id));
    handleClose();
  }

  return (
    <>
      <IconButton onClick={handleOpen}>
        <ArrowDropDownIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {botState.bots.map((bot) => (
          <MenuItem
            key={bot.id}
            selected={botState.current === bot.id}
            onClick={() => handleSelectBot(bot)}
          >
            <Stack
              direction="row"
              spacing={1}
            >
              <BotAvatar
                botId={bot.id}
                sx={{ width: "24px", height: "24px" }}
              />
              <Typography fontFamily={fonts.geist}>{bot.name}</Typography>
            </Stack>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
